/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'jquery',
    'domReady!'
], function ($) {
    'use strict';

    const $toggleButton = $('.action.primary.add-review'),
          $addForm      = $('.block.review-add'),
          $reviewList   = $('#product-review-container');

    $toggleButton.click(function () {
        $toggleButton.children('.action-option').toggle();
        $addForm.slideToggle(200);
        $reviewList.slideToggle(200);
    });
});